import { useCallback, useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { selectedCFDState } from 'features/cfd/state/cfdAtoms';
import { apiRenderKeyState } from 'shared/state/renderKeyAtoms';
import { authTokenState } from 'features/auth/state/authAtoms';
import { fetchCFDResult } from 'features/cfd/api/fetchCFDResult';

const isSameStatus = (a: unknown, b: unknown): boolean => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export const useCFDSelection = () => {
  const [selectedCFD, setSelectedCFD] = useRecoilState(selectedCFDState);
  const authToken = useRecoilValue(authTokenState);
  const renderKey = useRecoilValue(apiRenderKeyState);

  const syncSelectedCFD = useCallback(async (name: string) => {
    if (authToken === '') return;

    const status = await fetchCFDResult(authToken, name);
    setSelectedCFD((prev) => (isSameStatus(prev, status) ? prev : status));
  }, [authToken, setSelectedCFD]);

  const handleSelectedCFDChange = useCallback(async (name: string) => {
    if (authToken === '') return;

    const status = await fetchCFDResult(authToken, name);
    setSelectedCFD(status);
  }, [authToken, setSelectedCFD]);

  // 選択中のCFDの状態を最新化する
  useEffect(() => {
    if (!selectedCFD?.name) return;
    void syncSelectedCFD(selectedCFD.name);
  }, [renderKey, selectedCFD?.name, syncSelectedCFD]);

  return {
    selectedCFDName: selectedCFD?.name || '',
    handleSelectedCFDChange,
  };
};
